import { ProjectNorthDirection } from "../types/ProjectNorthDirection";

/**
 * Orients decimal degrees based on the given true north direction.
 * Useful when calculating the compass rotation based on the user's
 * drag input.
 *
 * @param {number} dd - The decimal degrees to be oriented.
 * @param {ProjectNorthDirection} direction - The direction to which the degrees should be oriented.
 * @returns {number} The oriented decimal degrees.
 */
export function orientDD(dd: number, direction: ProjectNorthDirection): number {
  return direction === "east" ? dd : 360 - (dd % 360);
}
